import { UserUrl } from "./AUrl";
import axios, { AxiosResponse } from "axios";
import { getJwt } from "../../../LocalStorage/AuthSession/core";
import { LoginResponse, UserSession } from "./login";

export interface UpdateSessionRoleSchema {
    refresh_token_id: string;
    role: string;
    entity_type: "institution" | "department";
    entity_id: number;
}

export interface ApiResponse {
    status: number;
    error?: string;
    data?: LoginResponse;
}

export type UpdateRoleType = (payload: UpdateSessionRoleSchema) => Promise<ApiResponse>;

export async function updateRole(payload: UpdateSessionRoleSchema): Promise<ApiResponse> {
    const url = new UserUrl().updateRole;
    const jwt = getJwt();
    if (!jwt) {
        return { status: 401, error: "JWT has expired" };
    }
    let response: AxiosResponse<any>;
    try {
        response = await axios.post<ApiResponse | string>(url, payload, {
            headers: {
                'Content-Type': 'application/json',
                'token': jwt
            },
            validateStatus: () => true
        });
    } catch (error) {
        return {
            status: 500,
            error: 'Network or other error occurred'
        };
    }

    if (response.status === 200) {
        return {
            status: response.status,
            data: response.data as LoginResponse
        };
    } else {
        return {
            status: response.status,
            error: response.data as string
        };
    }
}
